export enum UserPermissions {
  Admin = 'admin',
  Write = 'write',
  Read = 'read',
}
